import { render } from "./fzsjBorder.vue?vue&type=template&id=f72f57c4&scoped=true"
import script from "./fzsjBorder.vue?vue&type=script&lang=js"
export * from "./fzsjBorder.vue?vue&type=script&lang=js"

import "./fzsjBorder.vue?vue&type=style&index=0&id=f72f57c4&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f72f57c4"]])

export default __exports__